<template>
    <address class="about">
        <img class="background"
            :src="constants.backgrounds.aboutTheAuthor"/>
        <div class="authorDetails">
            <div class="user">
                <img class="avatar"
                    :src="avatar"
                    :alt="'Avatar of ' + currentUser.name"/>
                <div class="text">
                    <router-link class="name"
                        :to="'/creator/' + authorSlug">
                        {{ currentUser.name }}
                    </router-link>
                    <span class="author">
                        {{ siteContent.author }}
                    </span>
                </div>
            </div>
            <div class="socials">
                <Button class="social"
                    v-if="currentUser.instagram"
                    :link="'https://instagram.com/' + currentUser.instagram"
                    appearance="secondary"
                    size="fullWidth"
                    target="blank">
                        <div class="socialIcon instagramIcon"
                            :alt="'Instagram of ' + currentUser.name"></div>
                </Button>
                <Button class="social"
                    v-if="currentUser.website"
                    :link="'https://' + currentUser.website"
                    appearance="secondary"
                    size="fullWidth"
                    target="blank">
                        <Icon class="socialIcon"
                            icon="public"
                            appearance="white"/>
                </Button>
            </div>
        </div>
        <p class="intro">
            {{ currentUser.intro }}
        </p>
    </address>
</template>

<script>
    export default {
        name: 'AboutTheAuthor',
        props: {
            currentUser: Object,
            authorSlug: String
        },
        computed: {
            avatar() {
                if(this.currentUser.avatar) {
                    return this.currentUser.avatar
                } else {
                    return this.constants.defaults.avatar
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../scss/variables';

    .about {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-top: 4rem;
        background-size: cover;
        padding: 2.5rem 2.5rem 3.5rem 2.5rem;
        border-radius: 1.5rem;
        font-style: initial;
        overflow: hidden;
    }

    .background {
        position: absolute;
        object-fit: cover;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.7;
    }

    .authorDetails {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem;
    }

    .user {
        display: flex;
    }

    .text {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .avatar {
        width: 5rem;
        height: 5rem;
        margin-right: 1.5rem;
        border-radius: 2rem;
        display: block;
    }

    .name {
        font-family: $font-secondary;
        font-weight: 700;
        font-size: 1.5rem;
        margin: 0;
    }

    .author {
        margin: 0;
        color: var(--color-grey-600);
    }

    .socials {
        display: flex;

        .flat .socialIcon, .flat .instagramIcon {
            margin: 0;
        }
    }

    .social {
        margin-left: 1rem;
    }

    .intro {
        position: relative;
        margin: 0;
        white-space: pre-line;
        color: var(--color-white-important);
    }

    @media all and (max-width: 560px) {
        .about {
            padding: 1rem 1.5rem 2.5rem 1.5rem;
        }

        .authorDetails {
            flex-direction: column;
            align-items: flex-start;
        }

        .user {
            margin-bottom: 1.5rem;
        }

        .socials {
            width: 100%;
        }

        .social {
            margin: 0 1rem 0 0;

            &:last-of-type {
                margin: 0;
            }
        }
    }
</style>